export enum IconSize {
  SMALL = '24',
  MEDIUM = '40',
  LARGE = '48',
}

export enum CardSize {
  DEFAULT = 'default',
  WIDE = 'wide',
}

export interface DateRange {
  startDate: string;
  endDate: string;
  regDate?: string;
  today?: string;
}

export interface ActivityCardData {
  id: string;
  title: string;
  value: string;
  coverImage?: string;
}

export interface GroupOption {
  label: string;
  value: string;
}

export interface ActivityDashboardProps {
  cards: ActivityCardData[];
  dateRange?: DateRange;
  actionButton?: {
    text: string;
    onClick: () => void;
    className?: string;
  };
  dateRangeDescSuffix?: string;
  onCardClick?: (cardId: string) => void;
  onDateChange?: (startDate: string, endDate: string) => void;
  children?: React.ReactNode;
}

export interface ActivityCardProps extends ActivityCardData {
  onClick?: (id: string) => void;
}

export enum PanelType {
  LAST_STUDY = 'last-learning',
  LAST_ATTENDANCE = 'last-date',
  KEYWORD = 'keyword',
  TOOL = 'tool',
  CONTENT = 'content',
  TOTAL_TIME = 'total-time',
  TIME_RANGE = 'time-range',
  DAY = 'day',
  BOOK = 'book',
  FOCUS = 'focus',
  NOTE = 'note',
}

export interface PanelHeaderProps {
  cardId: string;
  title: string;
  isBeta?: boolean;
  onClose: () => void;
}

export interface RankItem {
  rank: number;
  name: string;
  value: number;
}

export interface BarGraphData extends RankItem {
  percentage?: number;
}

export interface KeywordData {
  rank: number;
  keyword: string;
}

export interface LastStudyData {
  bookTitle: string;
  bookCover?: string;
  page: number;
  status: number;
  description?: string;
}

export interface LastAttendanceData {
  lastDate: string;
  lastWeek: string;
  attendedDates: string[];
}

export interface PlainInfoData {
  startDate?: string;
  endDate?: string;
  mainValue: string;
  description: string;
  subtext?: string;
  min?: number;
  max?: number;
  total?: number;
  studentCount?: number;
}

export interface PanelConfig {
  id: PanelType;
  Component: React.ComponentType<any>;
  condition: boolean;
  props: any;
}

// Dashboard API 관련 타입들
// export interface DashboardRequestBody {
//   groupId?: string;
//   dateRange?: {
//     startDate: string;
//     endDate: string;
//   };
// }

// export interface DashboardSummaryResponse {
//   user: {
//     name: string;
//     type: 'teacher' | 'student';
//     email: string;
//   };
//   totalStats: {
//     totalStudents?: number;
//     totalGroups?: number;
//     totalActivities: number;
//   };
// }

// export interface DashboardGroupsResponse {
//   groups: GroupOption[];
//   defaultGroup?: string;
// }

// export interface DashboardActivityResponse {
//   activities: ActivityCardData[];
//   lastUpdated: string;
// }
